import React from 'react';

export const DOMAIN_PARKER = ".parker.com";
export const DOMAIN_TFS = ".totalfiltrationservices.com";
export const DOMAIN_BALDWIN = ".baldwinfilters.com";

export const Context = React.createContext({});